import { i18n } from 'services';

export const isArrayMinLength = (length: number) => (value: unknown) => {
  if (Array.isArray(value)) {
    return value.length < length ? i18n.t('formValidationErrors.isRequired') : undefined;
  }
  return i18n.t('formValidationErrors.isRequired');
};
